import httpbaseURL from "../../../../modules/Inventory/common/axios";
class AssetServiceManagementService {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetService/Create", doc);
  }
  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetService/Update", doc);
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/AssetService/List");
  }
  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/AssetService/Get?id=" + doc);
  }
}
export default new AssetServiceManagementService();
